import React from "react";
import { motion } from "framer-motion";

const ProfileDetailText = ({ text, label, textClassName }) => {
    return (
        <motion.div
            className="profile-ud-item"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, ease: "easeOut" }}
        >
            <div className="profile-ud wider">
                <motion.span
                    className="profile-ud-label"
                    initial={{ opacity: 0.6 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.6, ease: "easeInOut" }}
                >
                    {label}
                </motion.span>
                <motion.span
                    className={`profile-ud-value ${textClassName}`}
                    key={text} // 👈 ensures animation plays when text changes
                    initial={{ opacity: 0, x: -10 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.3, ease: "easeOut" }}
                >
                    {text}
                </motion.span>
            </div>
        </motion.div>
    );
};

export default ProfileDetailText;
